import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import TooglCustom from 'components/_parts/atoms/toogle';
import { useCreateActivityType, useUpdateActivityType } from 'components/company/api/useActivityType';
import { preparePayloadActivityType } from 'components/company/utils/preparePayload';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import './index.scss';
import initialValues from './initialValues';
import validationSchema from './validationSchema';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;

function WorkerType(props) {
  const { t } = props;

  const { mutate: createActivity } = useCreateActivityType();
  const { mutate: updateActivity } = useUpdateActivityType();

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ t }),
    onSubmit: (values) => {
      try {
        if (props.typeForm === 'edit') {
          const idActivity = props.dataActivityType.wla_activity_type_id;
          const payloadActivity = preparePayloadActivityType(values, idActivity);

          updateActivity(payloadActivity);
        } else {
          createActivity(values);
        }

        props.funcModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        formik.resetForm();
      }
    },
  });

  useEffect(() => {
    formik.setValues({
      activity_name:
        props.typeForm === 'create'
          ? ''
          : props.dataActivityType?.activity_name,
      order: props.typeForm === 'create' ? '' : props.dataActivityType?.order,
      status: props.typeForm === 'create' ? 'active' : props.dataActivityType?.status,
    });
  }, [props.dataActivityType, props.typeForm, props.modal]);

  useEffect(() => {
    if (props.showModal) {
      formik.resetForm();
    }
  }, [props.showModal, props.modal]);

  let checked_ = 0;
  if (formik.values.status !== undefined) {
    checked_ = formik.values.status === 'active' ? 0 : 1;
  }

  return (
    <div>
      {props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container-activity-type d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'edit' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} ${t('workload_landing.type_activity')}`}
              </Label>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.activity_name
                      && Boolean(formik.errors.activity_name)
                    }
                    validateMessage={formik.errors.activity_name}
                    type="text"
                    name="activity_name"
                    onChange={formik.handleChange}
                    value={formik.values.activity_name || ''}
                    placeholder={t('company.activity_name')}
                  />
                </div>
              </div>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.order && Boolean(formik.errors.order)
                    }
                    validateMessage={formik.errors.order}
                    type="number"
                    name="order"
                    onChange={formik.handleChange}
                    value={formik.values.order || ''}
                    placeholder={t('company.order')}
                  />
                </div>
              </div>
              { props.typeForm === 'edit' && (
              <div className="d-flex justify-content-between">
                <p style={{
                  fontSize: '12px', fontWeight: '700', fontFamily: 'Quicksand', paddingLeft: '5px',
                }}
                >
                  {t('job_desc.status')}
                </p>
                <TooglCustom
                  id="button-visibility"
                  name="status"
                  checked={checked_}
                  leftStatus={t('org.job_lvl.form.active')}
                  rightStatus={t('org.job_lvl.form.inactive')}
                  onChange={() => {
                    formik.setValues({
                      ...formik.values,
                      status:
                          formik.values.status === 'active' ? 'inactive' : 'active',
                    });
                  }}
                />
              </div>
              )}
              <div className="d-flex justify-content-end">
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('activity_type_list'),
        )}
    </div>
  );
}

export default WorkerType;
